module.exports = __webpack_public_path__ + "img/about-1.09057994.jpg";